import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoadingService } from 'src/app/generales/services/loading.service';
import { ToastService } from 'src/app/generales/services/toast.service';
import { environment } from 'src/environments/environment';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-edit-categorie',
  templateUrl: './edit-categorie.component.html',
  styleUrls: ['./edit-categorie.component.scss'],
})
export class EditCategorieComponent implements OnInit {
  @Input() categorie: any = { featured: '', name: '' };

  public url: string = environment.url;
  public smallImg: File = undefined;
  public largeImg: File = undefined;
  public previewLarge = undefined;
  public previewSmall = undefined;


  constructor(
    private adminService: AdminServiceService,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {}

  async editCategorie() {
    if(isNaN(this.categorie.type)){
      return this.toastService.show('Debes seleccionar un tipo de categoria.');
    }
    const categorieEdited: any = {
      featured: this.categorie.featured ? 1 : 0,
      name: this.categorie.name,
      type: this.categorie.type || 0
    };

    if (this.categorie.id) categorieEdited.id = this.categorie.id;

    const formData = new FormData();
    for (const key of Object.keys(categorieEdited)) {
      const value = categorieEdited[key];
      formData.append(key, value);
    }

    formData.append('largeImg', this.largeImg);
    formData.append('smallImg', this.smallImg);
    await this.loadingService.show();
    if (this.categorie.id) {
      this.adminService.editCategorie(formData).subscribe(async (res) => {
        await this.close();
      });
    } else {
      this.adminService.createCategorie(formData).subscribe(async (res) => {
        await this.close();
      });
    }
  }

  async close() {
    await this.loadingService.hide();
    await this.modalCtrl.dismiss();
  }

  changeImg(file: any, type: string) {
    const img = file.target.files[0];
    if (
      img.type.includes('png') ||
      img.type.includes('jpeg') ||
      img.type.includes('jpg') ||
      img.type.includes('webp')
    ) {
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = (e) => {
        if (type === 'large') {
          this.previewLarge = e.target.result;
          this.largeImg = img;
        } else {
          this.previewSmall = e.target.result;
          this.smallImg = img;
        }
      };
    } else {
      this.toastService.show('Debes insertar una imagen valida');
    }
  }
}
